var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.root
        ? _c("FramedComponent", {
            key: _vm.root.key,
            attrs: { root: _vm.root }
          })
        : _c("LoadingCover")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }